import React, { useEffect } from "react";
import HeroImg from "../Assets/img/isp-macbook.PNG";
import MissionImg from "../Assets/img/about-isp/mission-img.svg";
import WhyChoose from "../Components/WhyChoose";
import AboutUsSection from "../Components/AboutUsSection";
import ProductSlider from "../Components/ProductSlider";
import { Link } from "react-router-dom";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <!-- Hero-Area --> */}
      <section class="a-isp-area about-isp">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-12">
              <div class="a-isp-content">
                <h1>
                  About <b>ISP Digital</b>
                </h1>
                <p>
                  ISP Digital is a management and billing solution designed for
                  the ISP industry which helps to run ISP businesses more
                  efficiently and effectively. It assists with management and
                  billing solutions, including complete authorization,
                  operations, and billing management modules, as well as many
                  essential features that offer smooth operation for businesses.
                  It allows companies to track the quality of service with
                  customer usage and, through this software solution, the
                  billing process can be automated by sending invoices and
                  receiving payments. ISP Digital helps to lead in a competitive
                  market by providing excellent business management and a
                  high-quality internet connection in order to improve service
                  quality. See Pricing
                </p>
                <div class="a-isp-btn">
                  <Link to="/websubscription" class="theme-btn primary">
                    <i class="icofont-arrow-right"></i>See Pricing
                  </Link>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
              <div class="a-isp-img">
                <img src={HeroImg} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End-Hero-Area -->	 */}

      <section class="isp-mission-vission-area">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-12">
              <div class="isp-mission-top-content">
                <div class="mission-top-title">
                  <span>Know More ISP Digital</span>
                  <h4>ISP Digital</h4>
                </div>
                <div class="mission-top-content-inner">
                  <p>
                    ISP Digital (ISP Billing & Management Software) was created
                    in 2017 under the governance of SoftifyBD Limited. It was
                    developed with the goal of digitizing every aspect of the
                    ISP business activities. It benefits in many ways, as with
                    overall business activity, execution, and performance
                    analysis, it provides proper understanding and guidance to
                    achieve short-term and long-term goals and objectives. Over
                    time, ISP Digital has become essential software for quality
                    business management for many companies, and it has gained
                    popularity in Bangladesh as well as around the world.
                  </p>
                  <p>
                    SoftifyBD Limited updates the software on a regular basis,
                    not only to fix security holes and protect your data, but
                    also to add new features and improve existing ones for
                    better business management. ISP Digital software is
                    currently used by over 550+ ISP companies to manage
                    businesses all over the world.
                  </p>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
              <div class="mission-top-content-img">
                <img src={MissionImg} alt="#" />
              </div>
            </div>
          </div>
          {/* <div class="mission-bottom">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12">
                <div class="mission-bottom-content">
                  <h4 class="mission-bottom-title">Mission</h4>
                  <p>
                    Hendrerit metus arcu ipsum odio volutpat, pulvinar nibh
                    condimentum tellus. Porttitor mauris elit posuere enim.
                    Pellentesque gravida pellentesque integer tempus. Sed hac
                    aliquet adipiscing iaculis tristique vulputate. Sit congue
                    orci bibendum consectetur enim, habitant. Suscipit non dui,
                    fringilla nunc, turpis porta sit. Turpis eros risus morbi
                    gravida mi ultrices pulvinar quam. Nisi, integer pretium
                    quam vulputate. Aliquam quis amet senectus dignissim vitae,
                    sit imperdiet consequat purus. Tellus elementum elit.
                  </p>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-12">
                <div class="mission-bottom-content">
                  <h4 class="mission-bottom-title">Vision</h4>
                  <p>
                    Hendrerit metus arcu ipsum odio volutpat, pulvinar nibh
                    condimentum tellus. Porttitor mauris elit posuere enim.
                    Pellentesque gravida pellentesque integer tempus. Sed hac
                    aliquet adipiscing iaculis tristique vulputate. Sit congue
                    orci bibendum consectetur enim, habitant. Suscipit non dui,
                    fringilla nunc, turpis porta sit. Turpis eros risus morbi
                    gravida mi ultrices pulvinar quam. Nisi, integer pretium
                    quam vulputate. Aliquam quis amet senectus dignissim vitae,
                    sit imperdiet consequat purus. Tellus elementum elit.
                  </p>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
      <WhyChoose />
      <AboutUsSection />
      <ProductSlider />
    </>
  );
};

export default AboutUs;
